<!--
 * @FileDescription: 下载页>用于IOS唤醒跳转
 * @Author: Ronghao Zhu
 * @CreateTime: 2021/01/13 19:40:21
 * @LastEditors: Pound
 * @LastEditTime: 2021-05-10 10:07:53
-->

<template>
    <div class="download-wrap">跳转中...</div>
</template>

<script>
export default {
    name: 'downloadIosApp',
    components: {},
    props: {},
    data() {
        return {}
    },
    watch: {},
    created() {},
    mounted() {
        this.clickBtn()
    },
    methods: {
        clickBtn() {
            setTimeout(() => {
                this.$router.go(-1)
            }, 2000)
            window.location.href =
                'https://apps.apple.com/cn/app/%E8%A7%85%E7%AD%BE/id1542311569'
        }
    }
}
</script>

<style lang="scss" scoped>
.download-wrap {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
